import React from 'react';

// Custom X-Axis Tick for Multi-line text in Recharts
export const CustomXAxisTick = ({ x, y, payload }: any) => {
    if (!payload || !payload.value) return null;
    // Break the text into words
    const words = payload.value.split(' ');
    const lines: string[] = [];
    let currentLine = '';
    // Group words into lines, roughly 15 chars max per line to avoid too many small lines
    words.forEach((word: string) => {
        if ((currentLine + word).length > 15 && currentLine.length > 0) {
            lines.push(currentLine.trim());
            currentLine = word + ' ';
        } else {
            currentLine += word + ' ';
        }
    });
    if (currentLine.trim()) lines.push(currentLine.trim());

    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={15} textAnchor="middle" fill="#666" fontSize={11}>
                {lines.map((line, index) => (
                    <tspan x={0} dy={index === 0 ? 0 : 14} key={index}>
                        {line}
                    </tspan>
                ))}
            </text>
        </g>
    );
};
